// Markdown-to-plain-text stripper for TTS. The article body lives
// in our DB as Markdown so the renderer can show headings + links;
// the speech synth wants prose, not "[text](url)" or "## Heading".
//
// Coverage: headings, bold/italic, inline code, link text (drop the
// URL), strikethrough, blockquote markers, list bullets, horizontal
// rules. Code fences are stripped entirely — reading source code
// aloud is useless.

export function stripMarkdownForTts(md) {
  if (!md) return ''
  let out = String(md)

  // Strip fenced code blocks (```...``` and ~~~...~~~) before any
  // line-by-line work so multi-line code doesn't bleed into prose.
  out = out.replace(/```[\s\S]*?```/g, ' ')
  out = out.replace(/~~~[\s\S]*?~~~/g, ' ')

  // Inline code → just the contents (read it as a word).
  out = out.replace(/`([^`]+)`/g, '$1')

  // Images → drop alt text + URL completely.
  out = out.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')

  // Links → keep the visible text, drop the URL.
  out = out.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')

  // Strip residual bare URLs.
  out = out.replace(/https?:\/\/\S+/g, ' ')

  // Bold + italic markers.
  out = out.replace(/\*\*([\s\S]*?)\*\*/g, '$1')
  out = out.replace(/__([\s\S]*?)__/g, '$1')
  out = out.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1$2')
  out = out.replace(/(^|[^_])_([^_\n]+)_/g, '$1$2')

  // Strikethrough.
  out = out.replace(/~~([^~]+)~~/g, '$1')

  // Heading markers, blockquote markers, list bullets, hr.
  out = out.replace(/^\s{0,3}#{1,6}\s+/gm, '')
  out = out.replace(/^\s{0,3}>\s?/gm, '')
  out = out.replace(/^\s*[-*+]\s+/gm, '')
  out = out.replace(/^\s*\d+\.\s+/gm, '')
  out = out.replace(/^\s*-{3,}\s*$/gm, '')

  // HTML tags that might survive from imported sources.
  out = out.replace(/<[^>]+>/g, ' ')

  // Collapse whitespace.
  out = out.replace(/[ \t]+/g, ' ')
  out = out.replace(/\s*\n\s*\n+/g, '\n\n')
  return out.trim()
}
